import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, breadcrumb, actions, className }) {
  return (
    <div className={cn("flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-6", className)}>
      <div className="min-w-0">
        {breadcrumb && (
          <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-[#8B9698] mb-2">
            {breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-1.5">
                {i > 0 && <span className="opacity-50">/</span>}
                <span className={i === breadcrumb.length - 1 ? "text-[#00A85A]" : ""}>{b}</span>
              </span>
            ))}
          </div>
        )}
        <h1 className="text-2xl md:text-[28px] font-bold tracking-tight text-[#101516] dark:text-white truncate">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-[#687173] dark:text-[#8B9698]">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
